<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-col>
          <div style="display: flex; justify-content: flex-end">
            <v-btn color="primary" @click="removeBanner()">
              Xóa
            </v-btn>
          </div>
        </v-col>
        <v-col cols="12">
          <v-row>
            <v-col :cols="hiddenMobile ? 12 : 6" v-if="!hiddenDesktop">
              <v-col :cols="hiddenMobile ? 12 : 6">
                <v-file-input
                  label="Ảnh desktop"
                  placeholder="Tải ảnh lên"
                  prepend-icon="mdi-camera"
                  @change="fileBanner($event, 'photo_url')"
                ></v-file-input>
              </v-col>
              <v-img :src="photo_url"></v-img>
              <v-text-field v-if="photo_url"
                  background-color="#EDF2F7"
                  filled
                  label="Alt ảnh desktop"
                  v-model="data.alt_image"
                  placeholder="Nhập alt"
              ></v-text-field>
            </v-col>
            <v-col  :cols="hiddenDesktop ? 12 : 6" v-if="!hiddenMobile">
              <v-col :cols="hiddenDesktop ? 12 : 6">
                <v-file-input
                  label="Ảnh mobile"
                  placeholder="Tải ảnh lên"
                  prepend-icon="mdi-camera"
                  @change="fileBanner($event, 'photo_url_mobile')"
                ></v-file-input>
              </v-col>
              <v-img :src="photo_url_mobile"></v-img>
              <v-text-field v-if="photo_url_mobile"
                  background-color="#EDF2F7"
                  filled
                  label="Alt ảnh mobile"
                  v-model="data.alt_image_mobile"
                  placeholder="Nhập alt"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
      </v-col>
      <v-col cols="12">
        <v-select
          background-color="#EDF2F7"
          filled
          item-text="text"
          v-model="data.type"
          :items="types"
          item-value="id"
          label="Chọn loại Link"
        ></v-select>
      </v-col>
      <v-col cols="12" v-show="data.type == 2">
        <v-text-field
          background-color="#EDF2F7"
          filled
          v-model="data.link.url"
          item-text="name"
          item-value="id"
          label="Nhập đường dẫn"
        ></v-text-field>
      </v-col>
      <v-col cols="12" v-show="data.type == 1">
        <v-select
          background-color="#EDF2F7"
          filled
          item-text="name"
          v-model="data.link.type"
          :items="modlues"
          item-value="id"
          label="Chọn loại"
        ></v-select>
      </v-col>
      <v-col cols="12" v-show="data.type == 1">
        <v-autocomplete
          background-color="#EDF2F7"
          filled
          v-model="data.link.object_id"
          item-text="name"
          item-value="slug"
          :items="list_ids"
          label="Chọn ID"
        ></v-autocomplete>
      </v-col>
      <div></div>
    </v-row>
  </div>
</template>
<script>
import { GET_LIST_CATEGORY } from "@/store/modules/category";
import { GET_LIST_BRAND } from "@/store/modules/brand";
import { GET_LIST_TAG } from "@/store/modules/tag";
import { UPLOAD_IMAGE }from "@/store/modules/configs";
export default {
  props: {
    hiddenMobile: {
      type: Boolean,
      default: false
    },
    hiddenDesktop: {
      type: Boolean,
      default: false
    },
    banner: {},
    index: null
  },
  data() {
    return {
      photo_url :"",
      photo_url_mobile : "",
      list_ids: null,
      data: {
          alt_image: null,
          alt_image_mobile: null,
          photo_url: null,
          photo_url_mobile: null,
          photo_url_mobile_path :  null,
          photo_url_path : null,
          type: null,
          link: {
            brand_slug: null,
            type: null,
            object_id: null,
            url: null,
          },
      },
      types: [
        {
          id: 1,
          text: "Link theo loại",
        },
        {
          id: 2,
          text: "Link theo URL",
        },
      ],
      modlues: [
        {
          id: "category",
          name: "category",
        },
        {
          id: "brand",
          name: "brand",
        },
        {
          id: "tag",
          name: "tag",
        },
      ],
    };
  },
  methods: {
    fileBanner(event, type = 'photo_url') {
      if (event) {
        this[type] = URL.createObjectURL(event);
        let formData = new FormData();
        formData.append("upload", event);
        formData.append("type", "banners");
        this.$store
          .dispatch(`${UPLOAD_IMAGE}`, formData)
          .then((data) => {
            if (data && data.data && data.data.data) {
              data.data.data.forEach((element) => {
                this.data[type] = element.path;
              });
            }
          });
      }
    },
    removeBanner(){
      this.$emit("removeBanner", this.index);
    },
    setListByType(value){
      const _this = this;
      let url = "";
      if(value == "category"){
        url = GET_LIST_CATEGORY;
      }
      if(value == "brand"){
        url = GET_LIST_BRAND;
      }
      if(value == "tag"){
        url = GET_LIST_TAG;
      }
      if (url != "") {
        this.$store.dispatch(url).then((data) => {
          if (data && data.data && data.data.length > 0) {
            _this.list_ids = data.data;
          } else {
            _this.list_ids = [];
          }
        });
      }
    },
    updateLink(){
      this.data.link.brand_slug = null;
      if(this.data.link.type == "category"){
        let category = this.list_ids.find(item =>{
          return item.slug == this.data.link.object_id
        })
        this.data.link.brand_slug = category.brand_slug;
      }
    },
    emitUpdateBanner(){
      if(typeof this.data == 'object' && this.data !== null){
        this.updateLink();
        let data = {
          banner: this.data,
          index: this.index
        };
        this.$emit("updateBanner", data);
      }
    }
  },
  watch: {
    banner: {
      immediate: true,
      handler(val) {
        if(typeof val == 'object' && val !== null){
          this.data = val;
          this.photo_url = this.data.photo_url_path;
          this.photo_url_mobile = this.data.photo_url_mobile_path;
          if(this.data.type == 1){
            this.setListByType(this.data.link.type);
          }
        }
      }
    },
    data: {
      handler() {
        this.emitUpdateBanner();
      }
    },
    ['data.link']:{
      handler() {
        this.emitUpdateBanner();
      }
    },
    ['data.type'](value){
      if(value == 1){
        this.data.link.url = null;
      }
      if(value == 2){
        this.data.link.type = null;
        this.data.link.object_id = null;
      }
    },
    ['data.link.type'](value){
      this.setListByType(value);
    }
  },
  async created() {
      await this.banner == null;
  },
  mounted(){
    
  }
};
</script>